import { ConnectionNames } from "../../../Contracts";
import { applyRESTQueries } from "../../../Common";
export function applySearchQueries(message) {
    return applyRESTQueries(ConnectionNames.search, message);
}
//# sourceMappingURL=ApplySearchQueries.js.map